import { render, staticRenderFns } from "./MediaAttachment.vue?vue&type=template&id=2b4a52f9&scoped=true"
import script from "./MediaAttachment.vue?vue&type=script&lang=js"
export * from "./MediaAttachment.vue?vue&type=script&lang=js"
import style0 from "./MediaAttachment.vue?vue&type=style&index=0&id=2b4a52f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a52f9",
  null
  
)

export default component.exports